/**
 * Scrollen der Seite messen, egal wer scrollt (30.10.2026).
 *
 * Mit `html, body { height: 100%; overflow-x: hidden }` (App.css) scrollt auf den öffentlichen
 * Seiten `body` selbst, nicht das Fenster: `window.scrollY` bleibt 0, und Scroll-Ereignisse kommen
 * am Fenster nicht an. Der Bewertungshinweis kam deshalb nur nach Klicks, nie nach Scrollen.
 * Gemessen wird daher an allen drei Stellen, gehört wird mit `capture` am Dokument.
 */
export function seitenScrollY(): number {
  return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, document.body.scrollTop || 0);
}

/** Ruft `fn` bei jedem Scrollen der Seite; gibt die Abmeldung zurück. */
export function beiSeitenScroll(fn: () => void): () => void {
  document.addEventListener('scroll', fn, { capture: true, passive: true });
  return () => document.removeEventListener('scroll', fn, { capture: true });
}
